import api from "@services/api-service/api-service"

export const getLastConfigurations = async () => {
  try {
    const response = await api.get("/configurations/file/last/")
    return response.data
  } catch (error: any) {
    return Promise.reject(error)
  }
}
